"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticEmailBase = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
class AutomaticEmailBase {
    scheduledUntil;
    sentAt;
    acceptedAt;
    rejectedAt;
    deliveredAt;
    failedAt;
    openedAt;
    clickedAt;
    unsubscribedAt;
    complainedAt;
    storedAt;
    get status() {
        return (0, statusGetter_1.statusGetter)(this, AutomaticEmailBase, legacy_enums_1.AutomaticEmailStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.AutomaticEmailStatus.Failed:
                return {
                    failedAt: defined,
                    rejectedAt: undefined,
                };
            case legacy_enums_1.AutomaticEmailStatus.Complained:
                return {
                    complainedAt: defined,
                };
            case legacy_enums_1.AutomaticEmailStatus.Unsubscribed:
                return {
                    unsubscribedAt: defined,
                };
            case legacy_enums_1.AutomaticEmailStatus.Delivered:
                return {
                    deliveredAt: defined,
                };
            case legacy_enums_1.AutomaticEmailStatus.Rejected:
                return {
                    rejectedAt: defined,
                };
            case legacy_enums_1.AutomaticEmailStatus.Opened:
                return {
                    openedAt: defined,
                };
            case legacy_enums_1.AutomaticEmailStatus.Clicked:
                return {
                    clickedAt: defined,
                };
            case legacy_enums_1.AutomaticEmailStatus.Accepted:
                return {
                    acceptedAt: defined,
                    failedAt: undefined,
                    complainedAt: undefined,
                    openedAt: undefined,
                    unsubscribedAt: undefined,
                    deliveredAt: undefined,
                    rejectedAt: undefined,
                    clickedAt: undefined,
                };
            case legacy_enums_1.AutomaticEmailStatus.Scheduled:
                return {
                    scheduledUntil: defined,
                    sentAt: undefined,
                };
            case legacy_enums_1.AutomaticEmailStatus.Requested:
            default:
                return {
                    sentAt: defined,
                    failedAt: undefined,
                    openedAt: undefined,
                    deliveredAt: undefined,
                    clickedAt: undefined,
                    complainedAt: undefined,
                    unsubscribedAt: undefined,
                    acceptedAt: undefined,
                };
        }
    }
}
exports.AutomaticEmailBase = AutomaticEmailBase;
__decorate([
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "scheduledUntil", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "sentAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "rejectedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "deliveredAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "failedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "openedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "clickedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : new Date(value))),
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "unsubscribedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : new Date(value))),
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "complainedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : new Date(value))),
    __metadata("design:type", Date)
], AutomaticEmailBase.prototype, "storedAt", void 0);
//# sourceMappingURL=AutomaticEmailBase.js.map